export default {
  PROFILE: 0,
  CONFIGURATION: 1,
  BILLING: 2,
  LICENSING: 3,
};
